import { render } from "./Renew.vue?vue&type=template&id=f7c8e208&scoped=true"
import script from "./Renew.vue?vue&type=script&lang=js"
export * from "./Renew.vue?vue&type=script&lang=js"

import exportComponent from "D:\\code\\h5\\vue-lib\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7c8e208"]])

export default __exports__